import { render, staticRenderFns } from "./floatRight.vue?vue&type=template&id=b9784b80&scoped=true"
import script from "./floatRight.vue?vue&type=script&lang=js"
export * from "./floatRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9784b80",
  null
  
)

export default component.exports